// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AccessTokenModel from '../../model/access-token-model';
import AccessTokenDTO from '../dto/access-token-dto';
import dtoSchema from '../schemas/access-token-schema';

export default abstract class AccessTokenModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AccessTokenDTO>) {
    super();
    if (data) {
      this.token = data.token ?? undefined;
      this.expiresOn = data.expiresOn;
    }
  }
  /**
  */
  token?: string;
  /**
  * @type {date-time}
  */
  expiresOn?: string;

  static toModel(dto: DeepPartial<AccessTokenDTO>): AccessTokenModel;
  static toModel(dto: DeepPartial<AccessTokenDTO> | undefined | null): AccessTokenModel | undefined;
  static toModel(dto: DeepPartial<AccessTokenDTO> | undefined | null): AccessTokenModel | undefined {
    return dto ? new AccessTokenModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AccessTokenModel> | AccessTokenModel): AccessTokenDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      token: unwrapped.token,
      expiresOn: unwrapped.expiresOn,
    } as AccessTokenDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AccessTokenModel, can not map to AccessTokenDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
